@if (confirm$ | async; as confirmData) {
  <div class="modal-backdrop">
    <div class="modal-dialog" [class]="'modal-dialog--' + confirmData.type">
      <div class="modal-header">
        <div class="modal-icon">
          <fa-icon [icon]="getIcon(confirmData.type)" size="2x"></fa-icon>
        </div>
        <button class="modal-close" (click)="cancel()" aria-label="Cerrar">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <h3 class="modal-title">{{ confirmData.title }}</h3>
        <p class="modal-message">{{ confirmData.message }}</p>
      </div>
      <div class="modal-footer">
        <button class="app-btn app-btn--secondary" (click)="cancel()">
          {{ confirmData.cancelText }}
        </button>
        <button
          class="app-btn"
          [class.app-btn--primary]="confirmData.type !== 'danger'"
          [class.app-btn--danger]="confirmData.type === 'danger'"
          (click)="confirm()"
        >
          {{ confirmData.confirmText }}
        </button>
      </div>
    </div>
  </div>
}
